import React from "react";
import SessionTitle from "../SectionTitle";
import GiftItem from "../GiftItem";
import iconBaby from "../../assets/images/icons/icon-baby.png";
import iconBirthday from "../../assets/images/icons/icon-birthday.png";
import iconGraduation from "../../assets/images/icons/icon-graduation.png";
import iconEntrance from "../../assets/images/icons/icon-entrance.png";
import iconChristmas from "../../assets/images/icons/icon-christmas.png";
import iconGift from "../../assets/images/icons/icon-gift.png";
import "./index.scss";

interface GiftDecorFeaturesProps {
  gift1: string;
  gift2: string;
  gift3: string;
  gift4: string;
  flag_color: string;
}

const GiftDecorFeatures: React.FC<GiftDecorFeaturesProps> = ({
  gift1,
  gift2,
  gift3,
  gift4,
  flag_color,
}) => {
  const styleHightLight: React.CSSProperties = {
    height: "30px",
    backgroundColor: flag_color === "blue" ? "#00A5D9" : "#FFAF00",
  };

  const styleFeatures: React.CSSProperties = {
    backgroundColor: flag_color === "blue" ? "#DCF8FE" : "#FFF0DF",
    padding: "50px 0 30px 0",
    position: "relative",
    height: "745px",
  };

  return (
    <>
      <div style={styleHightLight}></div>
      <div style={styleFeatures}>
        <div className="embel-position gift-1">
          <img src={gift1} alt="gift_01_私の写真の贈り物" className="embel" loading="lazy" decoding="async" />
        </div>
        <div className="embel-position gift-2">
          <img src={gift2} alt="gift_02_私の写真の贈り物" className="embel" loading="lazy" decoding="async" />
        </div>
        <div className="embel-position gift-3">
          <img src={gift3} alt="gift_03_私の写真の贈り物" className="embel" loading="lazy" decoding="async" />
        </div>
        <div className="embel-position gift-4">
          <img src={gift4} alt="gift_04_私の写真の贈り物" className="embel" loading="lazy" decoding="async" />
        </div>
        <SessionTitle
          title="GIFT"
          subtitle="こんな時に絵本を贈ろう"
          background={flag_color === "blue" ? "#00A5D9" : "#FFAF00"}
          color={flag_color === "blue" ? "#005582" : "#782D00"}
        />

        <div className="icon-container">
          <div className="inline-group">
            <GiftItem
              title="出産祝い／記念に"
              imgUrl={iconBaby}
              alt="出産祝い_じぶんえほん"
              size="50%"
            />
            <GiftItem
              title="誕生日に"
              imgUrl={iconBirthday}
              alt="誕生日に_じぶんえほん"
              size="60%"
            />
          </div>
          <div className="inline-group">
            <GiftItem
              title="卒園／卒業記念に"
              imgUrl={iconGraduation}
              alt="卒園／卒業記念に_じぶんえほん"
              size="80%"
            />
            <GiftItem
              title="入園／入学記念に"
              imgUrl={iconEntrance}
              alt="入園／入学記念に_じぶんえほん"
              size="90%"
              nested
            />
          </div>
          <div className="inline-group">
            <GiftItem
              title="クリスマス"
              subtitle="プレゼントに"
              imgUrl={iconChristmas}
              alt="クリスマスプレゼントに_じぶんえほん"
              size="50%"
            />
            <GiftItem
              title="お祝い返しや"
              subtitle="各種お礼に"
              imgUrl={iconGift}
              alt="お祝い返しや各種お礼に_じぶんえほん"
              size="60%"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default GiftDecorFeatures;
